import moment from "moment"
import './modifiedlocalesv';
import './modifiedlocaleen';

export default (lang) => {
    moment.locale(lang)
}